import API from "../utils/api";

const createReturn        = async (data)   => (await API.post(`/api/sale-returns`, data)).data;
const getReturns          = async (params) => (await API.get(`/api/sale-returns`, { params })).data;
const getSingleReturn     = async (id)     => (await API.get(`/api/sale-returns/${id}`)).data;
const getReturnableItems  = async (saleId) => (await API.get(`/api/sale-returns/sale/${saleId}/returnable`)).data;

const saleReturnService = {
  createReturn, getReturns, getSingleReturn, getReturnableItems,
};
export default saleReturnService;